import socketio from 'socket.io-client';

// Create socket instance with better configuration
export const socket = socketio(process.env.REACT_APP_SOCKET_URL, {
  transports: ['websocket', 'polling'],
  upgrade: true,
  rememberUpgrade: true,
  timeout: 20000,
  forceNew: false,
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionAttempts: 5,
  maxReconnectionAttempts: 5,
  autoConnect: false // Don't auto-connect, we'll connect after authentication setup
});

// Authentication state
let isAuthenticated = false;
let pendingAuth = null;

// Function to authenticate user with socket
export const authenticateSocket = (userId, ejecutivoId = null, isAdmin = false) => {
  console.log('Authenticating socket with userId:', userId, 'ejecutivoId:', ejecutivoId, 'isAdmin:', isAdmin);
  
  const authData = { userId };
  
  if (ejecutivoId) {
    authData.ejecutivoId = ejecutivoId;
  }
  
  if (isAdmin) {
    authData.isAdmin = true;
  }
  
  if (socket.connected) {
    socket.emit('authenticate', authData);
    isAuthenticated = true;
    pendingAuth = null;
  } else {
    // Store auth data for when socket connects
    pendingAuth = authData;
    if (!socket.connected) {
      socket.connect();
    }
  }
};

// Function to check if socket is authenticated
export const isSocketAuthenticated = () => isAuthenticated;

// Add connection debugging
socket.on('connect', () => {
  console.log('Socket connected with ID:', socket.id);
  console.log('Socket transport:', socket.io.engine.transport.name);
  
  // Send pending authentication if available
  if (pendingAuth) {
    console.log('Sending pending authentication:', pendingAuth);
    socket.emit('authenticate', pendingAuth);
    isAuthenticated = true;
    pendingAuth = null;
  }
});

socket.on('disconnect', (reason) => {
  console.log('Socket disconnected:', reason);
  isAuthenticated = false;
  
  if (reason === 'io server disconnect') {
    // the disconnection was initiated by the server, you need to reconnect manually
    socket.connect();
  }
});

socket.on('connect_error', (error) => {
  console.error('Socket connection error:', error);
  isAuthenticated = false;
});

socket.on('reconnect', (attemptNumber) => {
  console.log('Socket reconnected after', attemptNumber, 'attempts');
  
  // Re-authenticate after reconnection
  if (pendingAuth) {
    console.log('Re-authenticating after reconnection:', pendingAuth);
    socket.emit('authenticate', pendingAuth);
    isAuthenticated = true;
  }
});

socket.on('reconnect_error', (error) => {
  console.error('Socket reconnection error:', error);
});

socket.on('reconnect_failed', () => {
  console.error('Socket reconnection failed');
  isAuthenticated = false;
});

// Add transport upgrade logging
socket.io.on('upgrade', () => {
  console.log('Socket transport upgraded to:', socket.io.engine.transport.name);
});

// Listen for authentication confirmation from server (if your backend sends it)
socket.on('authenticated', (data) => {
  console.log('Socket authentication confirmed:', data);
  isAuthenticated = true;
});

socket.on('authentication_error', (error) => {
  console.error('Socket authentication error:', error);
  isAuthenticated = false;
});